<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div class="background">
    <div class="cigent-box">
        <div class="text-content">
            <span class="subtitle">{{smallTitle}}</span>
            <h2 class="title">
                {{largeTitle}}
            </h2>
            <div class="description" [ngStyle]="{'margin-right': descriptionMarginRight}">
                <p>{{description}}</p>
            </div>
        </div>
        <div class="secure">
            <img width="800" height="683" src="../../../../assets/secure-file-sharing-large.png" loading="lazy" alt="Generic image for file sharing">
        </div>
    </div>
</div>
